import * as Yup from 'yup';

const productJourneySchema = Yup.object().nullable();

export default productJourneySchema;
